import {Action} from '@ngrx/store';
import {User} from 'oidc-client';

// import { Profile } from 'src/app/service-layer/models';

export enum AuthActionTypes {
  LoginAction = '[Login] Action',
  LoginActionSuccess = '[LoginSuccess] Action',
  LoginActionFailure = '[LoginFailure] Action',
  LoginWaitAction = '[LoginWait] Action',
  LoginCallBackAction = '[LoginCallBack] Action',
  CallBackAfterRegistrationAction = '[CallBackAfterRegistration] Action'
}

export class LoginAction implements Action {
  readonly type = AuthActionTypes.LoginAction;
}

export class LoginActionSuccess implements Action {
  readonly type = AuthActionTypes.LoginActionSuccess;
  constructor(public payload: { user: User, isAuthorized: boolean }) { }
}

export class LoginActionFailure implements Action {
  readonly type = AuthActionTypes.LoginActionFailure;
  constructor(public payload: { isAuthorized: boolean }) { }
}

export class LoginWaitAction implements Action {
  readonly type = AuthActionTypes.LoginWaitAction;
}

export class LoginCallBackAction implements Action {
  readonly type = AuthActionTypes.LoginCallBackAction;
}

export class CallBackAfterRegistrationAction implements Action {
  readonly type = AuthActionTypes.CallBackAfterRegistrationAction;
}

export type AuthActions = LoginAction | LoginActionSuccess | LoginActionFailure | LoginWaitAction | LoginCallBackAction | CallBackAfterRegistrationAction;
